import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { CommonModule, NgIf } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CompanyInfo } from '../../../shared/models/config-data.model';
import { SharedModule } from '../../../shared/shared.module';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'direct-footer',
  template: `
    <footer class="footer d-flex flex-wrap mt-auto py-2 bg-body-tertiary">
      <div class="container-fluid">
          <!-- <div >
            <span *ngIf="!isMobile" class="company-icon">
              <img src="/assets/{{companyName}}/logo/LogoFooter-Desktop.png" alt="{{companyName}} Logo">
            </span>
          </div> -->
          <div *ngIf="isMobile" class="company-icon d-flex">
            <div class="col center-img" >
              <img src="/assets/{{companyName}}/logo/LogoFooter-Mobile.svg" alt="{{companyName}} Logo">
            </div>
          </div>
          <ul class="direct-footer-menu d-flex flex-wrap align-items-center justify-content-center py-1 my-2">
            <!-- <li class="nav-item navbar-brand company-icon">
                <span *ngIf="isMobile">
                  <img src="/assets/{{companyName}}/logo/LogoFooter-Mobile.png" alt="{{companyName}} Logo">
                </span>
            </li> -->
            <li class="nav-item"><a href={{siteAddress}} class="nav-link ">&copy; {{currentYear}} {{companyName}}</a></li>
            <li class="nav-item footer-spacer">|</li>
            <li class="nav-item"><a href="{{summaryOfBenefitsLink}}" class="nav-link" target="_blank" rel="noopener noreferrer">Summary of Benefits</a></li>
            <li class="nav-item footer-spacer">|</li>
            <li class="nav-item"><button type="button" class="nav-link footer-link-button" data-bs-toggle="modal" data-bs-target="#dialog-privacy">Privacy</button></li>
            <li class="nav-item footer-spacer">|</li>
            <li class="nav-item"><button type="button" class="nav-link footer-link-button" data-bs-toggle="modal" data-bs-target="#dialog-terms">Terms & Legal</button></li>
            <li class="nav-item footer-spacer">|</li>
            <li class="nav-item"><button type="button" class="nav-link footer-link-button" data-bs-toggle="modal" data-bs-target="#dialog-accessibility">Website Accessibility</button></li>
            <li class="nav-item footer-spacer">|</li>
            <li class="nav-item"><button type="button" class="nav-link footer-link-button" data-bs-toggle="modal" data-bs-target="#dialog-faq">FAQ</button></li>
          </ul>
      </div>
    </footer>
  `,
  styleUrls: ['./direct-footer.component.scss'],
  host: {'class': 'direct-footer'},
  standalone  : true,
  imports: [ NgIf, HttpClientModule ] 
})
export class DirectFooterComponent implements OnInit {
  isHandsetPortrait: boolean = false;
  currentYear: any = new Date().getFullYear();

  isMobile: boolean = false;

  siteAddress: string = "";
  companyName: string = "";
  privacyLink: string = "";
  termsLink: string = "";
  summaryOfBenefitsLink: string = "";

  constructor(
    public dialog: MatDialog,
    private readonly responsive: BreakpointObserver,
  ) {

  }

  async ngOnInit(){
    let companyInfo = environment.CompanyInfo as CompanyInfo;
    
    this.siteAddress = "https://www."+ companyInfo.CompanyName.toLowerCase() + ".com/";
    this.companyName = companyInfo.CompanyName;
    this.privacyLink = companyInfo.PrivacyLink;
    this.termsLink = companyInfo.TermsLink;
    this.summaryOfBenefitsLink = companyInfo.SummaryOfBenefitsLink;



    this.responsive.observe(Breakpoints.HandsetPortrait).subscribe(result => {
      this.isHandsetPortrait = false;

      if (result.matches) {
        this.isHandsetPortrait = true;
      }
    })

    this.responsive.observe([
      Breakpoints.Small,Breakpoints.XSmall
      ])
      .subscribe(result => {
        this.isMobile = false; 
        if (result.matches) 
          this.isMobile = true;      
    });
  }


  openDialog(id: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = id;
    if(!this.isHandsetPortrait){
      dialogConfig.width = '900px';
    }else{
      dialogConfig.maxWidth = '95%';
    }
    this.dialog.open(DirectFooterDialogComponent, dialogConfig);
  }

}

@Component({
  selector: 'direct-footer-dialog',
  template:`
  <button class="x" mat-dialog-close (click)="closeDialog()">x</button>
  <h1 mat-dialog-title align="center">{{title}}</h1>

  <mat-dialog-content *ngIf="title === 'Disclaimer'">
  <p>
    Preview contracts at {{companyName}}.com. Coverage, deductibles, rental car benefits and qualifying breakdown claims vary depending on vehicle age, mileage, preexisting conditions, and the program selected. <strong><u> markets vehicle service contracts administered by American Auto Shield</u></strong>, 1597 Cole Blvd #200, Lakewood, CO 80401; FLORIDA License number: W111454. Parts of like kind and quality may be used including remanufactured parts.  does not offer coverage in California, but may refer a licensed CA Mechanical Breakdown Insurer.
    </p>
    <p>
    & {{companyName}}.com is not affiliated with any auto dealer or manufacturer. You will be contacted by e-mail, phone, and/or text once we receive your quote submission. Texas, Wisconsin, and Florida Residents: Contracts administered by American Auto Shield, 1597 Cole Blvd #200, Lakewood, CO 80401; Florida License #W111454. Parts of like kind and quality may be used including remanufactured parts. Vehicle names, logos, brands, & other trademarks featured or referred to within  are property of their respective trademark holders. 
    <img src="https://j4f6f5q7.stackpathcdn.com/img/poweredby.png" alt="powered by" title="powered by">
    </p>
  </mat-dialog-content>


  <mat-dialog-actions align="center">
    <button color="primary" mat-flat-button mat-dialog-close (click)="closeDialog()" >Close</button>
  </mat-dialog-actions>

  `,
  styleUrls: ['./direct-footer.component.scss'],
  standalone: true,
  imports: [
    SharedModule, 
    MatDialogActions, 
    MatDialogContent , 
    HttpClientModule, 
    CommonModule
  ]
})
export class DirectFooterDialogComponent {
  title: string;
  companyName: string = "";
  
  constructor(
    private readonly dialogRef: MatDialogRef<DirectFooterDialogComponent>
  ){
    this.title = this.dialogRef.id;
  }

  async getValues(){
    this.companyName = environment.CompanyInfo.CompanyName;
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
